import { MetadataMap } from "./metadata-map";
import { getEntityPrototypeChain } from "./utils";
const LINKS_MAP = new MetadataMap();
export function link(options) {
    const opts = options || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (target, key) => {
        LINKS_MAP.setMetadataByType(target.constructor, key, {
            name: key,
            ...opts,
        });
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function getLinkMetadata(target) {
    return getEntityPrototypeChain(target).reduce((soFar, prototype) => Object.assign(soFar, LINKS_MAP.getMetadataByType(prototype)), {});
}
